import type { Backend } from '@freelancer/datastore/core';
import {
  getQueryParamValue,
  OrderByDirection,
} from '@freelancer/datastore/core';
import {
  transformUserDocumentSubmissionFieldsToApi,
  transformUserDocumentSubmissionFilesToApi,
} from './user-document-submissions.transformers';
import type { UserDocumentSubmissionsCollection } from './user-document-submissions.types';

export function userDocumentSubmissionsBackend(): Backend<UserDocumentSubmissionsCollection> {
  return {
    defaultOrder: [
      {
        field: 'id',
        direction: OrderByDirection.ASC,
      },
    ],
    fetch: (authUid, ids, query, order) => {
      return {
        endpoint: 'users/0.1/self/documents',
        isGaf: false,
        params: {
          document_type_ids: getQueryParamValue(query, 'documentTypeId'),
          verification_process_type_ids:
            query?.searchQueryParams.verificationProcessTypeIds,
        },
      };
    },
    push: (authUid, userDocumentSubmission) => ({
      endpoint: 'users/0.1/self/documents',
      isGaf: false,
      payload: {
        document_type_id: userDocumentSubmission.documentTypeId,
        files: transformUserDocumentSubmissionFilesToApi(
          userDocumentSubmission.userDocumentFiles,
        ),
        fields: transformUserDocumentSubmissionFieldsToApi(
          userDocumentSubmission.userDocumentFields,
        ),
        expiry_date: userDocumentSubmission.expiryDate,
      },
    }),
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
